// Front/src/i18n/translations.js

const translations = {
    he: {
        myTasks: "📋 המשימות שלי",
        loading: "טוען משימות...",
        clientNumber: "מספר לקוח",
        checkClient: "🔍 בדוק לקוח",
        createClient: "➕ צור לקוח חדש",
        clientName: "👤 שם לקוח:",
        site: "📍 אתר לקוח:",
        start: "📅 הגעה:",
        contact: "📞 איש קשר:",
        status: "🛠 סטטוס:",
        notes: "🧾 הערות:",
        address: "📫 כתובת הגעה:",
        email: "✉️ אימייל:",
        subTasks: "⚖️ משימות קריאה:",
        noSubTasks: "🔍 לא נמצאו משימות לקריאה זו.",
        makat: "🏷️ מק\"ט:",
        serial: "🔢 מספר סידורי:",
        itemCode: "🔧 קוד פריט:",
        itemDesc: "📦 תיאור פריט:",
        comments: "📝 הערות:",
        internalId: "📌 מזהה פנימי:",
        lineNumber: "➖ מספר שורה בקריאה:",
        symboled: "🖼️ סמליל?",
        newReport: "➕ דו״ח מאזניים חדש",
        serviceNumber: "מס' קריאה:",
        arrow: "◀️",
        logout: "התנתקת",
        technet: "טקנט",
        dark: "חשוך",
        light: "מואר",
        login: "התחברות",
        loginWait: "מתחבר למערכת אנא המתן...",
        id: "משתמש:",
        password: "סיסמה:",
        loadingTasks: "טוען משימות אנא המתן...",
        createReport: "📄 צור דו\"ח חדש",
        uploading: "מעלה נתונים, אנא המתן...",
        submitReport: "שלח דו\"ח",
        check: "בדוק",
        checking: "בודק...",
        createScale: "➕ צור מאזניים חדשים",
        thermometerId: "מספר מד טמפרטורה ולחות:",
        weightSets: "סטים של משקולות:",        
        useCylinder1: "השתמש בסט גליל 1? (52)",
        useCylinder2: "השתמש בסט גליל 2? (20)",
        reportType: "סוג דו\"ח:",
        service: "שירות",
        marketing: "שיווק",
        scaleSerialId: "מספר סידורי של מאזניים:",
        weightUnit: "יחידות משקל:",
        accuracyClass: "דרגת דיוק:",
        dValue: "רזולוציה (d):",
        eValue: "שגיאה מותרת (e):",
        maxValue: "ערך מקסימלי:",
        minValue: "ערך מינימלי:",
        nValue: "חלוקות (n):",
        temperatureStart: "טמפרטורה בתחילה:",
        tests: "בדיקות:",        
        linearity: "לינאריות",
        corners: "פינות",
        repeatability: "חזרתיות",
        tare: "טרה",
        allowedDeviation: "סטיות מותרות?",
        addMoreLines: "הוסף שורות נוספות (10 במקום 6)",
        cornersTest: "בדיקת פינות (33% מקס):",
        repeatabilityTest: "בדיקת חזרתיות (80% מקס):",
        tareTest: "בדיקת טרה (33%~67% מקס):",        
        symbolled: "הדפסת סמליל?",
        yes: "כן",
        no: "לא",
        nextCalibration: "כיול חוזר בעוד חודשים:",
        temperatureEnd: "טמפרטורה בסיום:",
        humidityEnd: "לחות בסיום:",
        generalComments: "הערות כלליות:",
        reviewSummary: "סיכום סקירה:",
        visual: "חזותי:",
        reset: "מנגנון איפוס:",
        tareMechanism: "מנגנון טרה:",
        leveling: "יישור:",
        printing: "הדפסה:",        
        useLoadingPermission: "שימוש בכמות משקולות מקסימלית שיש ברכב?",
        useCheckUpTo: "נבדק עד משקל מקסימלי באישור לקוח?",
        calibrationApproval: "אני מאשר/ת כי הזנתי את נתוני הכיול כנדרש, בדקתי את נכונותם ואת סבירות התוצאות שהופקו במערכת, וכי ניתן לשחרר את תעודת הכיול בהתאם לנהלי המעבדה.",
        errorUserNotLoggedIn: "המשתמש לא מחובר.",
        errorThermometer: "לא ניתן למצוא מזהה מדחום.",
        errorThermometerGeneral: "שגיאה במציאת מדחום:",
        errorWeightSets: "שגיאה בקבלת סטים של משקולות:",
        errorScaleIdEmpty: "מספר סידורי של מאזניים לא יכול להיות ריק:",
        errorScaleNotFound: "שגיאה: לא נמצאו מאזניים:",
        errorCheckingScale: "שגיאה בבדיקת מאזניים:",
        successScaleFound: "✅ מאזניים נמצאו בהצלחה!",
        errorValidation: "שגיאה באימות הנתונים:",
        successUpload: "✅ ההעלאה הצליחה!",
        errorUpload: "ההעלאה נכשלה:",
        errorSubmit: "שגיאה בשליחת הדו\"ח:",        
        errorRelog: "אנא התחבר למערכת.",
        enterThermometer: ":הזן מזהה מדחום",
        set1: "סט 1",
        set2: "סט 2",
        enterScaleSerial: ":הזן סיריאלי של מאזניים",
        enterTemperatureStart: ":הזן טמפרטורת התחלה",
        humidityStart: ":לחות בתחילה",
        enterHumidityStart: ":הזן לחות התחלה",
        weightValue: ":ערך משקל",
        loadValue: "העמסה:",
        unloadValue: "הורדה:",
        enterTemperatureEnd: ":הזן טמפרטורת סיום",
        enterHumidityEnd: ":הזן לחות סיום",        
        enterComments: "(אופציונלי) הזן הערות:",
        loadValueTare: ":ערך עומס (חייב להיות שלילי)",       
        submitButtonUploading: "מעלה...",
        submitButtonIdle: "שלח דו\"ח",
        linearityTest: "בדיקת ליניאריות:",
        topLeft: "#1 ימין עליון",
        topRight: "#2 שמאל עליון",
        bottomLeft: "#3 ימין תחתון",
        bottomRight: "#4 שמאל תחתון",
        select: "בחר",
        ok: "טוב",
        notOk: "לא טוב",
        notExist: "לא קיים",
        enterValue: ":הזן ערך",
        gram: "גרם",
        kilogram: "קילוגרם",
        miligram: "מיליגרם",
        lb: "ליברה",
        weight: "משקל",
        load: "העמסה",
        unload: "הורדה",
        emptyScaleSerial: "מספר סידורי של מאזניים לא יכול להיות ריק:",
        linearityInvalid: "כל ערכי בדיקת הליניאריות חייבים להיות מספרים חיוביים:",
        repeatabilityInvalid: "כל ערכי בדיקת החזרתיות חייבים להיות מספרים חיוביים:",
        cornersWeightInvalid: "בדיקת פינות: ערך המשקל חייב להיות מספר חיובי:",
        cornersLoadInvalid: "בדיקת פינות: כל ערכי הקריאה חייבים להיות מספרים חיוביים:",
        tareInvalid: "בבדיקת טרה, ערך המשקל חייב להיות חיובי והעומס שלילי:",
        calibrationInvalid: "כיול חוזר חייב להיות מספר חיובי בין 1 ל־36:",
        tempHumidityInvalid: "טמפרטורה חייבת להיות בין 10–40°C ולחות בין 30–70%:",
        marketingTempHumidityInvalid: "טמפרטורה חייבת להיות בין 15–29°C ולחות בין 30–70%:",
        loadingPermissionInvalid: "יש להזין ערך חיובי עבור 'הרשאת טעינה':",
        checkUpToInvalid: "יש להזין ערך חיובי עבור 'בדיקה עד':",
        calibrationApprovalRequired: "יש לאשר את הצהרת הכיול לפני שליחת הדו\"ח.",
        scale_serial_required: "חובה להזין מספר סידורי:",
        scale_internal_id_required: "חובה להזין מזהה פנימי:",
        scale_client_id_required: "חובה להזין מזהה לקוח:",
        scale_catalog_required: "חובה להזין מק\"ט:",
        scale_max_invalid: "ערך מקסימלי חייב להיות מספר חיובי:",
        scale_min_invalid: "ערך מינימלי חייב להיות מספר חיובי:",
        scale_catalog_required_check: "חייב להיות קטלוג תקין.",
        scale_d_invalid: "ערך D חייב להיות מספר חיובי:",
        scale_e_invalid: "ערך E חייב להיות מספר חיובי:",
        scale_n_invalid: "ערך N חייב להיות מספר חיובי:",
        scale_accuracy_required: "חובה להזין מחלקת דיוק:",
        scale_weight_units_required: "חובה להזין יחידת משקל:",
        scale_success: "✅ מאזניים נוספו בהצלחה",
        scale_upload_error: "שגיאה בהעלאת נתוני המשקל:",
        scale_submit_error: "שגיאה בשליחת נתוני המשקל:",        
        addScale: "הוסף משקל חדש",
        clientID: "מזהה לקוח:",
        enterClientID: "הזן מזהה לקוח:",
        enterSerialNumber: "הזן מספר סידורי:",
        enterInternalId: ":הזן מזהה פנימי",
        catalogNumber: "מספר קטלוג:",
        enterCatalogNumber: "הזן מספר קטלוג:",
        selectAccuracyClass: "בחר מחלקת דיוק:",        
        one: "1",
        two: "2",
        three: "3",
        four: "4",
        submitScale: "שלח מאזניים",
        createClientTitle: "➕ יצירת לקוח חדש:",
        clientIdLabel: "🔢 מספר לקוח",
        clientNameLabel: "👤 שם (עברית/אנגלית)",
        clientAddressLabel: "📫 כתובת (עברית/אנגלית)",
        clientNameEngLabel: "👤 שם (אנגלית)",
        clientAddressEngLabel: "📬 כתובת (אנגלית)",
        phoneLabel: "📞 טלפון",
        faxLabel: "📠 פקס",
        emailLabel: "✉️ אימייל",
        contactSectionTitle: "👤 פרטי איש קשר",
        contactNameLabel: "👤 שם (עברית/אנגלית)",
        contactNameEngLabel: "👤 שם (אנגלית)",
        contactEmailLabel: "✉️ אימייל",
        contactPhoneLabel: "📞 טלפון",
        departmentSectionTitle: "🏢 מחלקה",
        departmentNameLabel: "🏷️ שם מחלקה",
        departmentPersonLabel: "👥 איש קשר במחלקה",
        submitClient: "💾 שמור לקוח",
        unknownError: "שגיאה לא ידועה:",
        clientAddedSuccess: "✅ לקוח נוצר בהצלחה!",
        clientAddedFailed: "יצירת הלקוח נכשלה:",
        catalogSuccess: "✅ פרטי קטלוג נמצאו בהצלחה",
        refreshTasks: "רענן משימות",
        goBack: "← חזור אחורה",
        fillAllClient: "אנא מלא את כל השדות החיוניים (מספר, שם, כתובת):",
        clientExists: "✅ לקוח קיים בדוקנט",
        clientApiCallFailed: "הקריאה לממשק הלקוח נכשלה:",
        loginFailed: "ההתחברות נכשלה:",
        loginFailedX: "ההתחברות נכשלה:",
        loginFailedServer: "התחברות נכשלה: אין תגובה מהשרת. אנא נסה שוב:",
        priorityConnectionFailed: "לא ניתן להתחבר למערכת Priority. נסה שוב מאוחר יותר:",
        priorityNoTasks: "לא נימצאו קריאות Priority. נסה שוב מאוחר יותר:",
        manufacturer: "יצרן:",
        model: "מודל:",
        createNewScaleType: "➕ יצירת סוג מאזניים חדש:",
        standard: "סטנדרט:",
        scaleTypeUploadError: "העלאת סוג מאזניים נכשלה:",
        eLowerThanD: "שגיאה מותרת (e) חייבת להיות גדולה או שווה ל- רזולוציה (d):",
        errorScaleOtherClient: "המספר הסיריאלי של המאזניים שייכים למספר לקוח אחר, צור מאזניים חדשים.",        
        serialAvailable: "מספר סיריאלי פנוי לשימוש ✅",
        serialAlreadyExists: "המספר הסיריאלי של המאזניים קיים כבר במערכת, אנא בחר מספר חדש:",
        errorScaleOtherClientSerial: "המספר הסיריאלי של המאזניים שייך למספר לקוח אחר, אנא בחר מספר חדש:",        
        cornersLoadNotDivisibleByD: ".כל ערכי השקילה בבדיקת הפינות חייבים להיות כפולה של d",
        tareNotDivisibleByD: ".כל ערכי השקילה בבדיקת הטרה חייבים להיות כפולה של d",
        linearityWeightInvalid: ".ערך משקל לא תקין בשורת לינאריות",
        linearityLoadInvalid: ".ערך שקילה לא תקין בשורת לינאריות",
        linearityLoadNotDivisibleByD: ".ערך השקילה בלינאריות חייב להיות כפולה של d",
        linearityUnloadInvalid: ".ערך שחרור לא תקין בשורת לינאריות",
        linearityUnloadNotDivisibleByD: ".ערך השחרור בלינאריות חייב להיות כפולה של d",
        repeatWeightInvalid: ".ערך משקל לא תקין בשורת חזרתיות",
        repeatLoadInvalid: ".ערך שקילה לא תקין בשורת חזרתיות",
        repeatLoadNotDivisibleByD: ".ערך השקילה בחזרתיות חייב להיות כפולה של d",
        scale_manufacturer_required: ".חובה להזין יצרן",
        scale_model_required: ".חובה להזין מודל",
        scale_units_required: ".חובה להזין יחידות",
        scale_class_type_required: "חובה להזין סוג מחלקת דיוק.",
        serviceCallDoesntExist: "מספר קריאת השירות לא קיים במערכת פריוריטי",
        searchServiceCall: "🔍 חיפוש קריאת שירות",
        search: "🔍 חפש",
        calibratorId: "מספר מזהה של הטכנאי המכייל:",
        totalSubtasks: "🔢 כמות משימות קריאה:",
        showDivisionTable: "הצג את רמת הדיוק והמינימום לשקילה",
        hideDivisionTable: "הסתר את רמת הדיוק והמינימום לשקילה",
        divisionN: "חלוקות (n)",    
        accuracyClassLabel: "דרגת דיוק",
        existsInDocnet: "דוח קיים בדוקנט?",
        existsInPriority: "קובץ קיים בפריוריטי?",
        errorCheckReport: "נכשלה הבדיקה למציאת דוח קודם",
        reportExists: "קיים כבר דוח למאזניים תחת קריאת השירות, תרצה לעדכן את הדוח?",
        clientIdExists: "✅ מספר לקוח קיים בדוקנט",
    },
    en: {
        myTasks: "📋 My Tasks",
        loading: "Loading tasks...",
        clientNumber: "Client Number:",
        checkClient: "🔍 Check Client",
        createClient: "➕ Create New Client",
        clientName: "👤 Client Name:",
        site: "📍 Site:",
        start: "📅 Start Date:",
        contact: "📞 Contact:",
        status: "🛠 Status:",
        notes: "🧾 Notes:",
        address: "📫 Address:",
        email: "✉️ Email:",
        subTasks: "⚖️ Subtasks:",
        noSubTasks: "🔍 No subtasks found for this call.",
        makat: "🏷️ Makat:",
        serial: "🔢 Serial Number:",
        itemCode: "🔧 Item Code:",
        itemDesc: "📦 Item Description:",
        comments: "📝 Comments:",
        internalId: "📌 Internal ID:",
        lineNumber: "➖ Line Number:",
        symboled: "🖼️ Symboled?",
        newReport: "➕ New Scale Report",
        serviceNumber: "Service Call Number:",
        arrow: "▶️",
        logout: "Logout",
        technet: "Technet",
        dark: "Dark",
        light: "Light",
        login: "Login",
        loginWait: "Logging in please wait...",
        id: "ID:",
        password: "Password:",
        loadingTasks: "Loading tasks please wait...",
        createReport: "📄 Create a New Report",
        uploading: "📤 Uploading, please wait...",
        submitReport: "Submit Report",
        check: "Check",
        checking: "Checking...",
        createScale: "➕ Create New Scale",
        thermometerId: "Thermometer ID:",
        weightSets: "Weight Sets:",
        useCylinder1: "Use Cylinder Set 1? (52)",
        useCylinder2: "Use Cylinder Set 2? (20)",
        reportType: "Report Type:",
        service: "Service",
        marketing: "Marketing",
        scaleSerialId: "Scale Serial ID:",
        weightUnit: "Weight Units:",
        accuracyClass: "Accuracy Class:",
        dValue: "Resolution (d):",
        eValue: "Permission error (e):",
        maxValue: "Max Value:",
        minValue: "Min Value:",
        nValue: "Interval (n):",
        temperatureStart: "Temperature Start:",
        tests: "Tests",
        linearity: "Linearity",
        corners: "Corners",
        repeatability: "Repeatability",
        tare: "Tare",
        allowedDeviation: "Allowed Deviations?",
        addMoreLines: "Add More Lines (10 rows instead of 6)",
        cornersTest: "Corners Test (33% Max):",
        repeatabilityTest: "Repeatability Test (80% Max):",
        tareTest: "Tare Test (33%~67% Max):",
        symbolled: "Symbolled Printing?",
        yes: "Yes",
        no: "No",
        nextCalibration: "Next Calibration In Months:",
        temperatureEnd: "Temperature End:",
        humidityEnd: "Humidity End:",
        generalComments: "Comments (optional):",
        reviewSummary: "Review Summary",
        visual: "Visual (at received time):",
        reset: "Reset Mechanism:",
        tareMechanism: "Tare Mechanism:",
        leveling: "Leveling:",
        printing: "Printing:",
        useLoadingPermission: "Used maximum available weights in car?",
        useCheckUpTo: "Tested to the maximum limit weight with customer approval?",
        calibrationApproval: "I confirm that I have entered the calibration data as required, verified their accuracy and the reasonableness of the results produced in the system, and that the calibration certificate can be released in accordance with the laboratory procedures.",
        errorUserNotLoggedIn: "User not logged in.",
        errorThermometer: "Could not find thermometer ID.",
        errorThermometerGeneral: "Error fetching thermometer ID:",
        errorWeightSets: "Error fetching weight sets:",
        errorScaleIdEmpty: "Scale Serial ID cannot be empty.",
        errorScaleNotFound: "Error: Scale Not Found.",
        errorCheckingScale: "Error checking scale:",
        successScaleFound: "✅ Scale found successfully!",
        errorValidation: "Validation error:",
        successUpload: "✅ Upload successful!",
        errorUpload: "Upload failed:",
        errorSubmit: "Error submitting report:",
        errorRelog: "Please login.",
        enterThermometer: "Enter thermometer ID",
        set1: "Set 1",
        set2: "Set 2",
        enterScaleSerial: "Enter Serial ID",
        enterTemperatureStart: "Enter temperature start",
        humidityStart: "Humidity Start:",
        enterHumidityStart: "Enter humidity start",
        weightValue: "Weight Value",
        loadValue: "Load",
        unloadValue: "Unload",
        enterTemperatureEnd: "Enter temperature end",
        enterHumidityEnd: "Enter humidity end",
        enterComments: "(optional) Enter comments",
        loadValueTare: "Load Value (Must be negative)",
        submitButtonUploading: "Uploading...",
        submitButtonIdle: "Submit Report",
        linearityTest: "Linearity Test:",
        topLeft: "#1 Top Left",
        topRight: "#2 Top Right",
        bottomLeft: "#3 Bottom Left",
        bottomRight: "#4 Bottom Right",
        select: "Select",
        ok: "OK",
        notOk: "NotOK",
        notExist: "NotExist",
        enterValue: "Enter value",
        gram: "g",
        kilogram: "kg",
        miligram: "mg",
        lb: "lb",
        weight: "Weight",
        load: "Load",
        unload: "Unload",
        emptyScaleSerial: "Scale Serial ID cannot be empty.",
        linearityInvalid: "All Linearity Test values must be positive numbers.",
        repeatabilityInvalid: "All Repeatability Test values must be positive numbers.",
        cornersWeightInvalid: "Corners Test: Weight Value must be a positive number.",
        cornersLoadInvalid: "Corners Test: All Load Values must be positive numbers.",
        tareInvalid: "Tare Test weight value must be positive and load value must be negative.",
        calibrationInvalid: "Next Calibration must be a positive number between 1 and 36.",
        tempHumidityInvalid: "Temperature must be between 10-40°C and humidity must be between 30-70%.",
        marketingTempHumidityInvalid: "Temperature must be between 15-29°C and humidity must be between 30-70%.",
        loadingPermissionInvalid: "Please enter a valid positive number for 'Loading Permission'.",
        checkUpToInvalid: "Please enter a valid positive number for 'Check Up To'.",
        calibrationApprovalRequired: "Please confirm the calibration declaration before submitting the report.",
        scale_serial_required: "Serial Number cannot be empty.",
        scale_internal_id_required: "Internal ID cannot be empty.",
        scale_client_id_required: "Client ID cannot be empty.",
        scale_catalog_required: "Catalog Number cannot be empty.",
        scale_max_invalid: "Max Value must be a positive number.",
        scale_min_invalid: "Min Value must be a positive number.",
        scale_catalog_required_check: "Catalog must be valid and exists in Docnet.",
        scale_d_invalid: "D Value must be a positive number.",
        scale_e_invalid: "E Value must be a positive number.",
        scale_n_invalid: "N Value must be a positive number.",
        scale_accuracy_required: "Accuracy Class cannot be empty.",
        scale_weight_units_required: "Weight Units cannot be empty.",
        scale_success: "✅ Scale added successfully!",
        scale_upload_error: "Error uploading scale data.",
        scale_submit_error: "Error submitting scale: ",
        addScale: "Add a New Scale",
        clientID: "Client ID:",
        enterClientID: "Enter Client ID",
        enterSerialNumber: "Enter Serial Number",
        enterInternalId: "Enter Internal ID",
        catalogNumber: "Catalog Number:",
        enterCatalogNumber: "Enter Catalog Number",
        selectAccuracyClass: "Select Accuracy Class",
        one: "1",
        two: "2",
        three: "3",
        four: "4",
        submitScale: "Submit Scale",
        createClientTitle: "➕ Create New Client",
        clientIdLabel: "🔢 Client ID",
        clientNameLabel: "👤 Name (Hebrew/English)",
        clientAddressLabel: "📫 Address (Hebrew/English)",
        clientNameEngLabel: "👤 Name (English)",
        clientAddressEngLabel: "📬 Address (English)",
        phoneLabel: "📞 Phone",
        faxLabel: "📠 Fax",
        emailLabel: "✉️ Email",
        contactSectionTitle: "👤 Contact Person",
        contactNameLabel: "👤 Name (Hebrew/English)",
        contactNameEngLabel: "👤 Name (English)",
        contactEmailLabel: "✉️ Email",
        contactPhoneLabel: "📞 Phone",
        departmentSectionTitle: "🏢 Department",
        departmentNameLabel: "🏷️ Department Name",
        departmentPersonLabel: "👥 Department Contact",
        submitClient: "💾 Save Client",
        unknownError: "Unknown Error.",
        clientAddedSuccess: "✅ Client added successfully.",
        clientAddedFailed: "Failed to create client.",
        catalogSuccess: "✅ Catalog details retrieved successfully!",
        refreshTasks: "Refresh Tasks",
        goBack: "← Go Back",
        fillAllClient: "Please fill out all necessary data (name, number, address).",
        clientExists: "✅ Client exists in docnet.",
        clientApiCallFailed: "Client API call failed",
        loginFailed: "Login failed.",
        loginFailedX: "Login failed.",
        loginFailedServer: "Login failed: No response from server. Please try again.",
        priorityConnectionFailed: "Unable to connect to the Priority system. Please try again later.",
        priorityNoTasks: "No service calls were found in the Priority system. Please try again later.",
        manufacturer: "Manufacturer:",
        model: "Model:",
        createNewScaleType: "➕ Create new scale type",
        standard: "Standard:",
        scaleTypeUploadError: "Scale Type Upload Failed",
        eLowerThanD: "Permission error (e) must be greater than or equal to Resolution (d)",
        errorScaleOtherClient: "This scale serial ID already belongs to another client, create a new scale.",
        serialAvailable: "✅ Serial number is available for use.",
        serialAlreadyExists: "This serial number already exists, please choose a different serial number.",
        errorScaleOtherClientSerial: "This scale serial ID already belongs to another client, please choose a different serial number.",
        cornersLoadNotDivisibleByD: "All corners load values must be divisible by d.",
        tareNotDivisibleByD: "Tare load value must be divisible by d.",
        linearityWeightInvalid: "Invalid weight value in linearity row",
        linearityLoadInvalid: "Invalid load value in linearity row",
        linearityLoadNotDivisibleByD: "Linearity load value must be divisible by d",
        linearityUnloadInvalid: "Invalid unload value in linearity row",
        linearityUnloadNotDivisibleByD: "Linearity unload value must be divisible by d",
        repeatWeightInvalid: "Invalid weight value in repeatability row",
        repeatLoadInvalid: "Invalid load value in repeatability row",
        repeatLoadNotDivisibleByD: "Repeatability load value must be divisible by d",
        scale_manufacturer_required: "Manufacturer is required.",
        scale_model_required: "Model is required.",
        scale_units_required: "Units are required.",
        scale_class_type_required: "Class Type is required.",
        serviceCallDoesntExist: "The service call number does not exist in priority.",
        searchServiceCall: "🔍 Search service call",
        search: "🔍 Search",
        calibratorId: "Calibrator ID:",
        totalSubtasks: "🔢 Amount of subtasks:",
        showDivisionTable: "Show the accuracy level and minimum weight",
        hideDivisionTable: "Hide the accuracy level and minimum weight",
        divisionN: "Divisions (n)",
        accuracyClassLabel: "Accuracy Class",
        existsInDocnet: "Scale Report exists in Docnet?",
        existsInPriority: "PDF File exists in priority?",
        errorCheckReport: "Failed to check if scale report exists.",
        reportExists: "A report for this scale and service call already exists in docnet. Do you want to update it?",
        clientIdExists: "✅ Client ID exists in Docnet.",
    },
  };
  
  export default translations;